import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layout/MainLayout';
import { Toaster } from 'react-hot-toast';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import MyOrders from './pages/MyOrders';
import ProductDetails from './pages/ProductDetails';
import PaymentCallback from './pages/PaymentCallback';
import OrderDetailsPage from './pages/OrderDetailsPage';
import PaymentsPage from './pages/PaymentsPage';
import ShipmentPage from './pages/ShipmentPage';
import WishlistPage from './pages/WishlistPage';
import ProductListingPage from './pages/ProductListingPage';
import UserProfilePage from './pages/UserProfilePage';
import HelpCenter from './pages/support/HelpCenter';
import ContactUs from './pages/support/ContactUs';
import AboutUs from './pages/support/AboutUs';
import FAQ from './pages/support/FAQ';
import { PrivacyPolicy, TermsOfService } from './pages/support/LegalPages';

// Placeholder Pages
const Clothing = () => <div><h1 className="text-3xl font-bold">Clothing</h1></div>;

// Layout Wrapper
const LayoutWrapper = ({ children }) => {
  return <MainLayout>{children}</MainLayout>;
};

// Protected Route Wrapper
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  // if (!user) return <Navigate to="/login" />; // Optional: enforce login
  return children;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: 'rgba(27, 13, 11, 0.9)', // emba-dark with opacity
                color: '#fff',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                padding: '16px 24px',
                borderRadius: '12px',
                fontSize: '14px',
                fontWeight: '400',
                letterSpacing: '0.02em',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
                maxWidth: '400px',
              },
              success: {
                iconTheme: {
                  primary: '#10b981',
                  secondary: '#fff',
                },
                style: {
                  borderLeft: '4px solid #10b981',
                },
              },
              error: {
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
                style: {
                  borderLeft: '4px solid #ef4444',
                },
              },
            }}
          />
          <Routes>
            {/* Auth Routes (No Layout) */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Main App Routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <LayoutWrapper><Home /></LayoutWrapper>
              </ProtectedRoute>
            } />
            <Route path="/cart" element={<LayoutWrapper><CartPage /></LayoutWrapper>} />
            <Route path="/wishlist" element={<LayoutWrapper><WishlistPage /></LayoutWrapper>} />
            <Route path="/search" element={<LayoutWrapper><ProductListingPage /></LayoutWrapper>} />
            <Route path="/category/:slug" element={<LayoutWrapper><ProductListingPage /></LayoutWrapper>} />
            <Route path="/product/:id" element={<LayoutWrapper><ProductDetails /></LayoutWrapper>} />
            <Route path="/checkout" element={<LayoutWrapper><CheckoutPage /></LayoutWrapper>} />
            <Route path="/payment/callback" element={<LayoutWrapper><PaymentCallback /></LayoutWrapper>} />
            <Route path="/orders" element={<LayoutWrapper><MyOrders /></LayoutWrapper>} />
            <Route path="/orders/:id" element={<LayoutWrapper><OrderDetailsPage /></LayoutWrapper>} />
            <Route path="/payments" element={<LayoutWrapper><PaymentsPage /></LayoutWrapper>} />
            <Route path="/shipment" element={<LayoutWrapper><ShipmentPage /></LayoutWrapper>} />
            <Route path="/settings" element={<LayoutWrapper><UserProfilePage /></LayoutWrapper>} />
            <Route path="/clothing" element={<LayoutWrapper><Clothing /></LayoutWrapper>} />

            {/* Support Routes */}
            <Route path="/help" element={<LayoutWrapper><HelpCenter /></LayoutWrapper>} />
            <Route path="/contact" element={<LayoutWrapper><ContactUs /></LayoutWrapper>} />
            <Route path="/about" element={<LayoutWrapper><AboutUs /></LayoutWrapper>} />
            <Route path="/faq" element={<LayoutWrapper><FAQ /></LayoutWrapper>} />
            <Route path="/privacy" element={<LayoutWrapper><PrivacyPolicy /></LayoutWrapper>} />
            <Route path="/terms" element={<LayoutWrapper><TermsOfService /></LayoutWrapper>} />
          </Routes>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
